import React, {useEffect, useState} from 'react';
import background from './../../../Assets/Image/login-bg.jpg'
import axios from "axios";
import Constant from "../../../Constant";
import {useHistory} from "react-router-dom";

const Login = () => {
    const [input, setInput] = useState({})
    const [errors, setErrors] = useState([])

    const handleInput = (e) => {
        setInput(prevState => ({...prevState, [e.target.name]: e.target.value}))
    }
    const handleLogin = () => {
        axios.post(Constant.BASE_URL + '/login', input).then(res => {
            localStorage.admin_token = res.data.token
            localStorage.admin_name = res.data.name
            localStorage.admin_email = res.data.email
            setErrors([])

            history.push('/')
            window.location.reload()
        }).catch(errors => {
            if (errors.response.status === 422) {
                setErrors(errors.response.data.errors)
            }
        })
    }

    const history = useHistory();
    useEffect(() => {
        if (localStorage.admin_token !== undefined) {
            history.push('/')
            window.location.reload()
        }
    }, [])

    return (
        <div className={'login-container'}>
            <img src={background} alt={'Login Image'}/>
            <div className="login-card">
                <h4 className={'text-center'}>Admin Login</h4>
                <form>
                    <label className={'w-100 mt-1'}>
                        Email/Phone
                        <input
                            className={'form-control form-control-sm'}
                            placeholder={'Enter Name'}
                            type={'text'}
                            name={'email'}
                            value={input.email}
                            onChange={handleInput}
                        />
                        <p className={'login-error-message'}><small className={'text-danger'}>{errors.email !== undefined ? errors.email[0] : null}</small></p>
                    </label>
                    <label className={'w-100 mt-3'}>
                        Password
                        <input
                            className={'form-control form-control-sm'}
                            placeholder={'Enter Name'}
                            type={'password'}
                            name={'password'}
                            value={input.password}
                            onChange={handleInput}
                        />
                        <p className={'login-error-message'}><small className={'text-danger'}>{errors.password != undefined ? errors.password[0] : null}</small></p>

                    </label>
                    <div className="d-grid mt-4">
                        <button onClick={handleLogin} type={'button'} className={'btn btn-outline-info btn-sm'}>Login</button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default Login;
